import { Injector } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { validRouteHook } from './hooks/valid-route.hook';

/**
 * UIRouter configuration handler.
 * @param router
 * @param injector
 */
export function appRouterConfigFn(router: UIRouter, injector: Injector) {
    validRouteHook(router.transitionService);
}